import React from 'react';

import BillingPlans from './header/Billing.Plans';
import BillingPaymentCards from './header/Billing.PaymentCards';

interface IBillingHeadersProps {}

const BillingHeaders = ({}: IBillingHeadersProps) => {
  return (
    <div>
      <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2">
        <BillingPlans />
        <BillingPaymentCards />
      </dl>
    </div>
  );
};

export default React.memo(BillingHeaders);
